import env from "@/env";
import { postForm } from "@/utils/request";

const OauthQueryConst = {
  client_id: env.OauthCId,
  client_secret: env.OauthCSecret,
};

// Oauth2登录认证
export type IReqOauth = {
  auto_regist: string;
  grant_type: string;
  ticket: string;
};
export function oauthLogin(data: IReqOauth) {
  return postForm<any>({
    baseURL: env.centerUrl,
    url: "/UAA/oauth/token",
    data: { ...data, ...OauthQueryConst },
    notNeedToken: true,
  });
}
